/**
 * The client app's Messages store: a client and the salons they book with.
 * Its own store (not the salon's), so a salon owner browsing their client
 * dashboard sees their own salon chats here, never their salon's inbox.
 *
 * TO LAUNCH: swap the stand-in for the real client adapter, keep the
 * contract (api.js, plus pickSlot, payDeposit, startedForm, submitForm and
 * openSalon from clientAdapter.js).
 */
import { createMessagesStore } from './store';
import { createClientMockAdapter } from './clientAdapter';

export const clientStore = createMessagesStore({
    makeAdapter: () => createClientMockAdapter(),
    keyOf: () => `client:${localStorage.getItem('userId') || ''}`,
});

/** Unread across all salon chats, for the Messages tab and sidebar. */
export function useClientUnread() {
    return clientStore.useMessagesState((s) => clientStore.selectSpaceUnread(s, 'salons'));
}
